import * as React from 'react';
import { styled, composeRenderFunction } from './druid/./druid/Utilities';
import { IContextualMenuProps, IContextualMenuStyleProps, IContextualMenuStyles } from '/druid/ContextualMenu.types';
import { ContextualMenuBase } from '/druid/ContextualMenu.base';
import { getStyles } from '/druid/ContextualMenu.styles';

function onRenderSubMenu(subMenuProps: IContextualMenuProps) {
  return <LocalContextualMenu {...subMenuProps} />;
}

// This is to prevent cyclic import with ContextualMenu.base.tsx.
const LocalContextualMenu: React.FunctionComponent<IContextualMenuProps> = styled<
  IContextualMenuProps,
  IContextualMenuStyleProps,
  IContextualMenuStyles
>(
  ContextualMenuBase,
  getStyles,
  (props: IContextualMenuProps) => ({
    onRenderSubMenu: props.onRenderSubMenu
      ? composeRenderFunction(props.onRenderSubMenu, onRenderSubMenu)
      : onRenderSubMenu,
  }),
  { scope: 'ContextualMenu' },
);

/**
 * ContextualMenu description
 */
export const ContextualMenu: React.FunctionComponent<IContextualMenuProps> = LocalContextualMenu;
